import React from 'react';
import { motion } from 'framer-motion';
import { fadeIn, slideIn } from '../utils/motion';
import { styles } from '../styles';
import { SectionWrapper } from '../hoc'; // Import SectionWrapper

const PartnerSection = () => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 mt-10">
    <div className="sm:col-span-1 flex flex-col justify-center">
      <motion.div variants={slideIn()}>
        <h3 className="font-bold text-3xl text-white">Onze Partner</h3>
        <motion.p
          variants={fadeIn("", "", 0.1, 1)}
          className={`mt-4 ${styles.sectionSubText} text-secondary max-w-3xl leading-[30px]`}
        >
          Onze partner in Nepal voor fairtrade producten is <strong>Manushi</strong>. Zij waren de eerste fairtrade organisatie in Nepal en zijn inmiddels meer dan 25 jaar actief.
          Zij begeleiden kleine ondernemers in productie, financiering en coaching en checken of aan alle Fairtrade vereisten is voldaan. Manushi koopt de producten tegen een eerlijke prijs op van lokale kleinschalige ondernemers en verkoopt ze door als gecertificeerd fair-trade product.
          <br /><br />
          Daarnaast heeft Manushi ook eigen werkplaatsen waar ze zelf producten maakt en werkgelegenheid biedt aan vrouwen uit achterstandsposities. 
Ter gelegenheid van het 25 jarig jubileum heeft Manushi deze 
<a 
  href="/Catalogs/Manushicatalog.pdf" 
  target="_blank" 
  rel="noopener noreferrer" 
  className="text-blue-400 underline"
>
  catalogus
</a> 
uitgebracht. Op aanvraag leveren wij de artikelen uit de catalogus.
 <br /><br />
          Een deel van de artikelen staat met prijzen genoemd in onze eigen catalogussen op deze site. Bel of mail ons als u interesse heeft in één van deze artikelen.
          Indien prijzen nog niet op onze website genoemd staan vragen wij deze voor u na. Artikelen die wij in voorraad hebben en reeds verkopen staan op <a href="https://www.manavta.nl" className="underline text-secondary">www.manavta.nl</a>.
        </motion.p>
      </motion.div>
    </div>

    <div className="sm:col-span-1 flex flex-col items-center justify-center space-y-6">
      <motion.div variants={slideIn()} className="flex flex-col items-center space-y-6">
        <motion.img
          whileHover={{ scale: 1.1 }}
          transition={{ type: "spring", stiffness: 300 }}
          src="src/assets/man.jpg"
          alt="Manushi Logo"
          className="w-48 h-auto object-contain cursor-pointer"
        />
        <motion.img
          whileHover={{ scale: 1.1 }}
          transition={{ type: "spring", stiffness: 300 }}
          src="src/assets/manavta.png"
          alt="Manavta Logo"
          className="w-48 h-auto object-contain cursor-pointer"
        />
        <motion.img
  whileHover={{ scale: 1.1 }}
  transition={{ type: "spring", stiffness: 300 }}
  src="/fair.png"
  alt="Fair Trade Logo"
  className="w-48 h-auto object-contain cursor-pointer"
/>

      </motion.div>
    </div>
  </div>
);

// Export wrapped in SectionWrapper, with id "partner"
export default SectionWrapper(PartnerSection, "partner");
